import { Badge, Button } from '@commenda/kakashi';
import { TWorkflowTemplateCategory } from '@commenda/types';
import { cn } from '@commenda/utils';
import { WorkflowTemplateMetadataHelper } from './workflow-template-metadata';

interface WorkflowListFiltersProps {
  categories: TWorkflowTemplateCategory[];
  selectedCategory: TWorkflowTemplateCategory | null;
  onCategoryToggle: (category: TWorkflowTemplateCategory) => void;
  tags: string[];
  selectedTags: string[];
  onTagToggle: (tag: string) => void;
  onTagFiltersClear: () => void;
}

const filterChipClassName = (isSelected: boolean) =>
  cn('rounded-full', !isSelected && 'opacity-60 hover:opacity-100');

/** The affiliate console's category and tag filter bars; either bar hides itself when the list
 * carries no values for it. */
export const WorkflowListFilters = ({
  categories,
  selectedCategory,
  onCategoryToggle,
  tags,
  selectedTags,
  onTagToggle,
  onTagFiltersClear,
}: WorkflowListFiltersProps) => {
  return (
    <>
      {categories.length > 0 && (
        <div className="flex flex-wrap items-center gap-md">
          <span className="txt-small-regular text-text-tertiary">
            Filter by category:
          </span>
          {categories.map((category) => {
            const isSelected = selectedCategory === category;
            return (
              <button
                key={category}
                type="button"
                aria-pressed={isSelected}
                onClick={() => onCategoryToggle(category)}
                className={filterChipClassName(isSelected)}
              >
                <Badge size="sm" variant={isSelected ? 'blue' : 'gray'}>
                  {WorkflowTemplateMetadataHelper.CATEGORY_LABELS[category]}
                </Badge>
              </button>
            );
          })}
        </div>
      )}

      {tags.length > 0 && (
        <div className="flex flex-wrap items-center gap-md">
          <span className="txt-small-regular text-text-tertiary">
            Filter by tag:
          </span>
          {tags.map((tag) => {
            const isSelected = selectedTags.includes(tag);
            return (
              <button
                key={tag}
                type="button"
                aria-pressed={isSelected}
                onClick={() => onTagToggle(tag)}
                className={filterChipClassName(isSelected)}
              >
                <Badge size="sm" variant={isSelected ? 'blue' : 'gray'}>
                  {tag}
                </Badge>
              </button>
            );
          })}
          {selectedTags.length > 0 && (
            <Button variant="tertiary" size="sm" onClick={onTagFiltersClear}>
              Clear
            </Button>
          )}
        </div>
      )}
    </>
  );
};
